import React, { Component } from "react";
import "./App.css";

import Main from "./components/main";

class App extends Component {
  render() {
    return (
      <div>
        <Main />
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js